import React, { Component } from 'react'
import { connect } from 'react-redux'

// Packages
import { Helmet } from 'react-helmet'

// Components
import Header from '../../../components/Global/Header'
import Footer from '../../../components/Global/Footer'
import AccountSettingsNav from '../../../components/UserPortal/AccountSettings/AccountSettingsNav'
import FormContainer from '../../../components/Global/FormContainer'
import AccountInfoForm from '../../../components/Forms/AccountInfoForm'
import FlashMessage from '../../../components/Global/FlashMessage'

// Actions
import {
  updateUserAccountInfo,
} from '../../../actions/user'

import {
  getProfileAccountDetails
} from '../../../actions/accountDetails'

class AccountInfo extends Component {
  state = {
    displayFlashMessage: false
  }

  componentDidMount() {
    const { user, activeProfile } = this.props

    this.props.getProfileAccountDetails(user, activeProfile.username)
  }

  handleFormSubmit = (accountInfoData) => {
    const { user } = this.props

    this.props.updateUserAccountInfo(user, accountInfoData)
      .then(response => {
        response.success ? this.handleSuccessfulSubmit() : console.log('Error')
      })
  }

  handleSuccessfulSubmit() {
    window.scrollTo(0, 0)
    this.setState({
      displayFlashMessage: true
    })
  }

  renderSuccessFlashMessage() {
    const { displayFlashMessage } = this.state

    return displayFlashMessage
    ? (
      <FlashMessage>
        Your changes have been saved successfully.
      </FlashMessage>
    ) : null
  }

  render() {
    const { path, appName } = this.props

    return (
      <div className="user-portal account-settings account-info">
        <Helmet>
          <title>{appName} | Settings: Account Info</title>
        </Helmet>
        <Header path={ path } />
        <AccountSettingsNav currentTab="account-info"  />
        <FormContainer>
          <header>
            <h1>Account Info</h1>
            <p className="note">
              Whether you're an athlete, parent, or other user, this screen shows who you are and your specific account information. This information is not displayed publicly.
            </p>
          </header>
          {this.renderSuccessFlashMessage()}
          <AccountInfoForm
            handleSubmit={(input) => this.handleFormSubmit(input)}
            submitButtonText="Save Changes"
          />
        </FormContainer>
        <Footer appName={ appName } path={ path } />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateUserAccountInfo: (user, accountInfoData) => dispatch(updateUserAccountInfo(user, accountInfoData)),
    getProfileAccountDetails: (user, athleteUsername) => {
      dispatch(getProfileAccountDetails(user, athleteUsername))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountInfo)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Settings/AccountInfo.js